import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FC, useState } from 'react';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';
import { useDeletePieceMutation } from 'src/redux/api/piece';

import { tooltips } from '@components/Capture/helper';

import { CaptureId } from '../../types';

type Props = {
  disabled?: boolean;
  onClick: (id: number) => void;
  id?: CaptureId | null;
  onMenuClose?: () => void;
};

const DeleteMenuAction: FC<Props> = ({ disabled, onClick, id, onMenuClose }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [deletePiece, { isLoading: isDeleteLoading }] = useDeletePieceMutation();
  return (
    <>
      <MenuItem onClick={() => setIsDialogOpen(true)} disabled={disabled} color="error">
        <ListItemIcon>
          <DeleteOutline color="error" />
        </ListItemIcon>
        <ListItemText sx={{ color: 'error.main' }}>{tooltips.DeleteOutlined}</ListItemText>
      </MenuItem>
      <DialogConfirmation
        maxWidth="xs"
        open={isDialogOpen}
        loading={isDeleteLoading}
        handleClose={() => setIsDialogOpen(false)}
        type="error"
        title="Delete item"
        content={'Are you sure you would like to permanently delete this item?'}
        acceptButtonTitle="Delete"
        acceptButtonHandleClick={async () => {
          if (!id) return;
          await deletePiece(+id);
          onClick(+id);
          setIsDialogOpen(false);
          onMenuClose?.();
        }}
        cancelButtonTitle="Cancel"
        cancelButtonHandleClick={() => setIsDialogOpen(false)}
      />
    </>
  );
};

export default DeleteMenuAction;
